import AmpersandState from 'ampersand-state';


const SessionCounters = AmpersandState.extend({

    props: {
        notifications: 'number',
        chatNewMessages: 'number'
    },

    increaseNotificationsCount(){
        this.notifications++;
    },

    setNotificationsCount(value){
        this.notifications = value;
    },

    getNotificationsCount(){
        return this.notifications;
    },

    setChatNewMessagesCount(value){
        this.chatNewMessages = value;
    },

    getChatNewMessagesCount(){
        return this.chatNewMessages;
    },

    increaseChatNewMessagesCount(){
        this.chatNewMessages++;
    },

    decreaseChatNewMessagesCount(value = 1){
        this.chatNewMessages -= value;
    },
});

module.exports = SessionCounters;